import { StudentGeneralInformationView } from "../../../models/views/identity/StudentGeneralInformationView ";

export default interface DefaultLayoutState {
    userInformation: StudentGeneralInformationView;
    showContactUs: boolean;
}
export interface DefaultLayoutProps {
    showFooter?: boolean;
    showContactUs?: boolean;
    showDefaultHeader?: DefaultLayoutHeaderType;
    backUri?: string;
    backIcon?: string;
    title?: string;
}

export enum DefaultLayoutHeaderType {
    showDefaultHeader,
    redirect,
    none
}